import {ChangeEvent} from 'react';

export enum UserTabs {
    UserDetails = 'UserDetails',
    UserActivity = 'UserActivity',
}

export enum UserStatuses {
    Active = 'Active',
    Deactivated = 'Deactivated',
}

export type SetCurrentTab = (value: UserTabs) => void;
export type HandleChange = (event: ChangeEvent<{}>, newValue: UserTabs) => void;
export type OnChange = (event: ChangeEvent<HTMLInputElement>, checked: boolean) => void;
